'use client'

import React, { memo } from 'react'
import Image from 'next/image'
import { useTranslations } from 'next-intl'
import {
  cartAllProductsSelector,
  cartProductItemsQtyCountSelector,
  cn,
  Price,
  storeConfigSelector,
} from '@segway/core'
import { useAppSelector } from '@segway/core/src/store/hooks'

import { useRouter } from '@/i18n/navigation'

const SettlementDetails = () => {
  const router = useRouter()
  const cartAllProducts = useAppSelector(cartAllProductsSelector)
  const cartProductItemsQtyCount = useAppSelector(cartProductItemsQtyCountSelector)
  const storeConfig = useAppSelector(storeConfigSelector)
  const t = useTranslations('Cart')

  return (
    <div className="mt-2 rounded-[12px] border-b border-[#E9E9E9] bg-white px-3 py-4 xl:mt-0 xl:rounded-none xl:px-0">
      <div className="flex items-center justify-between text-[16px]">
        <span className="xl:text-[16px]">
          Detalles de la liquidación({cartProductItemsQtyCount})
        </span>
        <span
          onClick={() => {
            router.push('/checkout/cart')
          }}
          className="mr-4 cursor-pointer text-[13px]">
          {t('edit_cart')}
        </span>
      </div>
      <div>
        {cartAllProducts.map((product) => {
          const { uid, quantity, rawProduct } = product
          return (
            <div
              key={uid}
              className="flex py-5 xl:py-6 [&:last-child]:pb-0 [&:not(:last-child)]:border-b [&:not(:last-child)]:border-[#F3F3F4]">
              <div className="flex h-[88px] basis-[88px] items-center justify-center overflow-hidden rounded-[8px] xl:rounded-none">
                <Image
                  src={rawProduct?.product?.image?.url ?? ''}
                  alt={rawProduct?.product?.image?.label ?? ''}
                  width={88}
                  height={88}
                />
              </div>
              <div className="ml-3 flex-1 space-y-4 truncate">
                <p className="text-[rgba(15, 15, 15, 1)] truncate font-miSansDemiBold450 text-[15px]">
                  {rawProduct.product.name}
                </p>
                {rawProduct.__typename === 'BundleCartItem' && rawProduct.bundle_options && (
                  <dl className="mb-3 text-base">
                    {rawProduct.bundle_options.map((bundleOption, index) => {
                      return (
                        <div
                          key={bundleOption?.uid}
                          className={cn('mb-1 flex flex-col xl:block xl:flex-row xl:pb-1', {
                            'items-start': index > 0,
                          })}>
                          <dt className="min-w-[8.5rem] font-miSansMedium380 text-[12px] text-[#0F0F0F]">
                            {bundleOption?.label === 'Product' ? 'Producto' : bundleOption?.label}
                            :&nbsp;
                          </dt>
                          {bundleOption?.values.map((option) => {
                            return (
                              <dd
                                key={option?.uid}
                                className={cn({
                                  'flex flex-col': bundleOption.values.length > 1,
                                })}>
                                <span className="flex justify-start whitespace-break-spaces font-miSansMedium380 text-[12px] text-[#0F0F0F] xl:block xl:items-center xl:pt-1">
                                  {option?.quantity} X {option?.label}
                                  &nbsp;
                                  <Price
                                    block={false}
                                    price={{ value: option?.price }}
                                    currencyStyle="text-base"
                                    textStyle="text-base"
                                    fractionStyle="text-base"
                                  />
                                  {!bundleOption.required && option?.saleable_stock === 0 && (
                                    <span className="ml-1 rounded bg-gray-8/20 px-1 text-white">
                                      Out of Stock
                                    </span>
                                  )}
                                </span>
                              </dd>
                            )
                          })}
                        </div>
                      )
                    })}
                  </dl>
                )}
                {!storeConfig?.is_price_include_tax && rawProduct?.prices?.row_total && (
                  <div className="flex justify-between pr-2">
                    <span>
                      <Price price={rawProduct.prices.row_total} />
                    </span>
                    <span>x{quantity}</span>
                  </div>
                )}
                {storeConfig?.is_price_include_tax &&
                  rawProduct?.prices?.row_total_including_tax && (
                    <div className="flex justify-between pr-2">
                      <span>
                        <Price price={rawProduct.prices.row_total_including_tax} />
                        <span>{t('vat_included')}</span>
                      </span>
                      <span>x{quantity}</span>
                    </div>
                  )}
              </div>
            </div>
          )
        })}
      </div>
      {/* TODO */}
      {/*<div className="mt-2 flex items-center">
        <MilpitasStoreIcon />
        <span className="ml-1">Pick up in store(1)</span>
      </div>
      <div className="xl:border-b xl:border-[#F3F3F4]">
        <div className="flex py-5">
          <div className="h-[88px] basis-[88px] rounded-[8px] bg-[#F8F8F9]" />
          <div className="ml-3 flex-1 space-y-4 truncate">
            <p className="truncate">Segway SuperScooter GT2九号平衡车（增强版）智能电动体感车</p>
            <p>minipro2, white</p>
            <div className="flex justify-between pr-2">
              <span>4999.89</span>
              <span>x1</span>
            </div>
          </div>
        </div>
      </div>*/}
    </div>
  )
}

export default memo(SettlementDetails)
